import { memoize } from '@exah/utils';
import { isReactProp } from './is-react-prop';
import { isHtmlProp } from './is-html-prop';
export function createIsPropValid(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$whitelist = _ref.whitelist,
      whitelist = _ref$whitelist === void 0 ? [] : _ref$whitelist,
      _ref$blacklist = _ref.blacklist,
      blacklist = _ref$blacklist === void 0 ? [] : _ref$blacklist;

  var checkFn = function checkFn(tagName, propName) {
    return whitelist.includes(propName) || !blacklist.includes(propName) && (isReactProp(propName) || isHtmlProp(propName, tagName));
  };

  return memoize(checkFn);
}